// ZB Scrolling Images — pause animation when off-screen for performance

(function () {
  function initScrollingImages(root) {
    var track = root.querySelector('[data-si-track]');
    if (!track || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          track.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
        });
      },
      { threshold: 0 }
    );

    observer.observe(root);
  }

  function initAll() {
    document.querySelectorAll('.zb-si').forEach(initScrollingImages);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.zb-si');
    if (root) initScrollingImages(root);
  });
})();